import { useIntl } from 'react-intl';

import {
	ProductGrid,
	useProductData,
	ProductCategory,
	ProductItem,
	categories,
} from '../product-subnav';

import { MobileNavTitle } from './mobile-nav-card';

export const MobileNavProductITProfessionals = () => {
	const intl = useIntl();
	const { productsByTag } = useProductData();
	const itProfessionalsProducts = productsByTag[ProductCategory.ITProfessionals] || [];

	return (
		<div>
			<MobileNavTitle
				title={intl.formatMessage(categories[ProductCategory.ITProfessionals].title)}
			/>
			<ProductGrid>
				{itProfessionalsProducts.map((product) => (
					<ProductItem
						key={product.id}
						{...product}
						currentCategory={ProductCategory.ITProfessionals}
					/>
				))}
			</ProductGrid>
		</div>
	);
};
